module.exports = __webpack_public_path__ + "img/kaishi.b4e6e9c4.png";